import { FC } from 'react';
import { useHistory } from 'react-router';
import { Image, VStack } from '@chakra-ui/react';

import IconButton from 'components/_core/IconButton';
import SunshineCard from 'components/_core/SunshineCard';
import Text from 'components/_core/Text';
import { ActionItem } from 'features/PostOnboardingAccountSetup/context';

interface AccountSetupActionCardProps {
  actionItem: ActionItem;
  onDismiss: (actionItem: ActionItem) => void;
}

const AccountSetupActionCard: FC<AccountSetupActionCardProps> = ({
  actionItem,
  onDismiss,
}) => {
  const { image, isCompleted, isMandatory, text, to } = actionItem;
  const history = useHistory();

  const handleOnRemove = (event: React.MouseEvent<SVGElement>) => {
    onDismiss(actionItem);
    event.stopPropagation();
  };

  return (
    <SunshineCard
      backgroundColor="grey.100"
      border={isCompleted ? '1px solid' : 'none'}
      isDisabled={isCompleted}
      key={text}
      onClick={() => history.push(to)}
      padding="8px 16px 24px"
      position="relative"
      width={200}
    >
      {isCompleted || isMandatory ? null : (
        <SunshineCard.Slot name="action">
          <SunshineCard.SunshineIcon
            _hover={{
              cursor: 'pointer',
            }}
            color="primary"
            name="cross"
            onClick={handleOnRemove}
            position="absolute"
            right="space-16"
            size="icon-16"
            top="space-16"
          />
        </SunshineCard.Slot>
      )}

      <VStack justifyContent="center" spacing="space-12" textAlign="center">
        <Image alt="" opacity={isCompleted ? 0.3 : 1} src={image} width={82} />

        <Text
          fontWeight="weight-500"
          opacity={isCompleted ? 0.3 : 1}
          size="lg"
          textDecoration={isCompleted ? 'line-through' : ''}
          textDecorationThickness="1px"
          variant="primary"
        >
          {text}
        </Text>

        <IconButton
          aria-label=""
          icon={isCompleted ? 'tick' : 'arrow-right'}
          isDisabled={isCompleted}
          variant="secondary"
        />
      </VStack>
    </SunshineCard>
  );
};

export default AccountSetupActionCard;
